/* Progressive enhancement: both classes remain readable without JavaScript. */
if (!customElements.get('rmc-season-classes')) {
  customElements.define('rmc-season-classes', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[data-season-panel]')];
      const select = index => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
      };
      tabs.forEach((tab, index) => {
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(next);
          tabs[next].focus();
        });
      });
      select(0);
      this.querySelector('[role="tablist"]').hidden = false;
    }
  });
}
